import actionTypes from './actionTypes';
import getActionCreator from '../libs/getActionCreator';

// eslint-disable-next-line import/prefer-default-export
export const getOpenStatsAction = getActionCreator(actionTypes.GET_OPEN_STATS);
